import { Button } from "@cynthai/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import PageContainer from "@/core/ui/layout/PageContainer";
import PageHeader from "@/core/ui/layout/PageHeader";
import { CreateAuditStatementTreeForm } from "@/features/classification/components/template-form/CreateAuditStatementTreeForm";
import { m } from "@/paraglide/messages";

export const Route = createFileRoute(
  "/_protected/template-editor/statement-trees/new",
)({
  component: NewAuditStatementTreePage,
});

function NewAuditStatementTreePage() {
  const navigate = useNavigate();
  return (
    <div className="scroll-area flex min-h-0 flex-1 flex-col overflow-y-auto [&>*]:shrink-0">
      <PageHeader title={m.statement_tree_create_title()} />
      <PageContainer className="h-auto overflow-visible pb-16 [&>*]:shrink-0">
        <Button
          size="sm"
          variant="ghost"
          className="self-start"
          onPress={() =>
            navigate({
              to: "/template-editor",
              search: {
                status: "approved",
                category: "statement_taxonomy",
                projectType: "audit",
              },
            })
          }
        >
          {m.statement_taxonomy_editor_back()}
        </Button>
        <CreateAuditStatementTreeForm />
      </PageContainer>
    </div>
  );
}
